import classnames from "classnames";
import PropTypes from "prop-types";
import "./TextInput.css";

function hasError(error) {
  return error && error.length > 0;
}
const TextInput = ({
  name,
  value,
  valueFront,
  label,
  id,
  validationError,
  type = "text",
  onChange,
  onRemove,
  index,
  onKeyPress,
  onBlur,
  placeholder,
  disabled,
  autofocus,
  autocomplete = "off",
  datalist,
}) => {
  return (
    <div
      className={classnames(
        "mb-3",
        validationError ? { "has-error": validationError } : ""
      )}
    >
      {label && (
        <label className="control-label" htmlFor={name}>
          {label}
        </label>
      )}
      <div className={valueFront ? "input-group" : ""}>
        <input
          className="form-control"
          onChange={onChange}
          onKeyPress={onKeyPress}
          onBlur={onBlur}
          value={value}
          type={type}
          name={name}
          placeholder={placeholder}
          id={id}
          disabled={disabled}
          autoFocus={autofocus}
          autoComplete={autocomplete}
          list={datalist && datalist.id ? datalist.id : undefined}
        />
        {datalist && datalist.id && datalist.datalist && (
          <datalist id={datalist.id}>
            {datalist.datalist.map((item) => (
              <option key={item}>{item}</option>
            ))}
          </datalist>
        )}
        {valueFront && (
          <span id="valueFront" className="btn btn-link">
            {valueFront}
          </span>
        )}
        {index !== undefined && index !== 0 && (
          <span className="btn btn-link" onClick={(e) => onRemove(e, index)}>
            <i className="intervallRemovesign fa fa-times-circle" />
          </span>
        )}
      </div>
      {hasError(validationError) && (
        <span className="validation-error">{validationError}</span>
      )}
    </div>
  );
};

TextInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueFront: PropTypes.any,
  label: PropTypes.string,
  validationError: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  autofocus: PropTypes.bool,
  onRemove: PropTypes.func,
  index: PropTypes.number,
  datalist: PropTypes.shape({
    id: PropTypes.string.isRequired,
    datalist: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default TextInput;
